const sections = [
  {
    h: 'Our commitment',
    p: 'True North Care & Support is committed to a website that is usable by seniors, families, and people of all abilities. We use large readable text (18px minimum body size), strong color contrast, large touch targets (48px minimum), clear headings, and visible focus indicators.',
  },
  {
    h: 'Ongoing improvement',
    p: 'We review the website regularly against accessibility best practices and welcome feedback about barriers you encounter.',
  },
  {
    h: 'Feedback',
    p: 'If any part of this website is difficult to use, please call +1 (825) 779-8783 or send a message through our contact page so we can help and improve.',
  },
]

export default function Accessibility() {
  return (
    <section style={{ padding: '72px 24px' }}>
      <div style={{ maxWidth: 820, margin: '0 auto' }}>
        <h1 style={{ margin: '0 0 12px 0', fontSize: 46, lineHeight: 1.1, color: 'var(--color-teal-900)' }}>Accessibility Statement</h1>
        <p style={{ margin: '0 0 40px 0', color: 'var(--color-muted)' }}>Last updated: July 2026</p>
        {sections.map((s) => (
          <div key={s.h} style={{ marginBottom: 32 }}>
            <h2 style={{ margin: '0 0 10px 0', fontSize: 28, lineHeight: 1.15, color: 'var(--color-teal-900)' }}>{s.h}</h2>
            <p style={{ margin: 0, fontSize: 17, color: 'var(--color-muted)' }}>{s.p}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
